import { clsx } from 'clsx';
import styles from '../Notifications.module.scss';
import { PipelineSubscriptionsListWrapper } from './components/PipelineSubscriptionsListWrapper';

export function Subscriptions() {
  return (
    <div className='h-100 flex-col'>
      <div className={clsx('body-container', styles.subscriptionsHeader)}>
        <div className='text-subheading-2'>Active Pipeline Subscriptions</div>
      </div>

      <div className='flex-1 overflow-hidden'>
        <PipelineSubscriptionsListWrapper />
      </div>
    </div>
  );
}
